import React from 'react'

/**
 * <Notice display_error={} display_notice={} notice_message={} />
**/
const Notice = (props) => {
  const {display_error, display_notice, notice_message} = props;
  const alertClass = display_error ? 'alert alert-danger' : 'alert alert-success';
  return (display_error || display_notice) ? (
    <div role='alert'
      className={`card inner-buffer ${alertClass}`}
    >
      {notice_message}
    </div>
  ) : '';
}

export default Notice;